import { KILO } from '../../constants/KILO_THEME'

type HealthMetricCardProps = {
  id?: string
  label: string
  value: number | string | null
  unit?: string
  trend?: 'up' | 'down' | 'stable' | null
  trendGood?: 'up' | 'down' | null
  subtitle?: string
  highlight?: boolean
}

const HealthMetricCard = ({
  label,
  value,
  unit,
  trend,
  trendGood,
  subtitle,
  highlight,
}: HealthMetricCardProps) => {
  const trendIcon = trend === 'up' ? '↑' : trend === 'down' ? '↓' : trend ? '→' : null
  const trendColor =
    trend && trendGood && trend === trendGood
      ? 'text-kilo-accent'
      : trend && trend !== 'stable'
        ? 'text-kilo-danger'
        : KILO.text.soft

  return (
    <div
      className={`relative rounded-2xl border p-5 transition-all ${
        highlight ? 'border-kilo-accent/30 bg-kilo-card' : 'border-kilo-border bg-kilo-card'
      }`}
    >
      <p className={`mb-2 text-xs font-bold uppercase tracking-widest ${KILO.text.soft}`}>{label}</p>
      <div className="flex items-end gap-2">
        <span className={`text-2xl font-semibold leading-none ${KILO.text.primary}`}>
          {value !== null && value !== undefined ? value : '—'}
        </span>
        {unit && value !== null && value !== undefined ? (
          <span className={`mb-1 text-sm ${KILO.text.muted}`}>{unit}</span>
        ) : null}
        {trendIcon ? <span className={`mb-1 text-sm ${trendColor}`}>{trendIcon}</span> : null}
      </div>
      {subtitle ? <p className={`mt-2 text-xs leading-relaxed ${KILO.text.soft}`}>{subtitle}</p> : null}
    </div>
  )
}

export default HealthMetricCard
